import { uniqueId } from 'underscore';
import { Bounds, namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractItem from './abstractItem';

namespace('Ofcs.Editor.Item');

/**
 * @class ContainerItem
 * @extends AbstractItem
 */
const ContainerItem = AbstractItem.extend({

    type: 'container',

    supportsMultiChildMove: true,

    supportsMultiChildCopy: true,

    /**
     * Triggered when the segments are updated
     *
     * @event updatesegments
     * @param {Ofcs.Editor.Item.CircleItem} item Me
     */

    defaults: {
        /**
         * @property {String} Type
         */
        type: null,

        /**
         * Current position
         * @property {Ofcs.Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Features
         * @cfg {Array} attributes.features
         */
        features: [],
    },

    initialize() {
        Ofcs.Editor.Item.AbstractItem.prototype.initialize.call(this);

        if (!this.has('identifier')) this.set('identifier', `new-${uniqueId()}`);

        const items = new Ofcs.Editor.Item.ItemCollection();
        if (this.attributes.items) {
            this.attributes.items.forEach(item => items.add(item));
        }
        this.items = items;
    },

    /**
     * @return {ItemCollection}
     */
    getItems() {
        return this.items;
    },

    /**
     * @param {AbstractItem} item
     * @return {boolean}
     */
    isItemSupported(item) {
        return !!item;
    },

    /**
     * Return a flat array of all descendants of this item
     * @return {AbstractItem[]}
     */
    getDescendants() {
        return this
            .getItems()
            .reduce((descendants, child) => {
                descendants.push(child);
                if (child instanceof ContainerItem) descendants.push(...child.getDescendants());
                return descendants;
            }, []);
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Ofcs.Bounds} Bounding box of the item
     */
    getBounds() {
        return this.cache.get('bounds', () => {
            const safetyMargin = this.getSafetyMargin();
            const cacheBounds = new Bounds(
                new Point(0 - safetyMargin, 0 - safetyMargin),
                new Point(this.get('width') + safetyMargin, this.get('height') + safetyMargin),
            );

            return cacheBounds;
        });
    },

    /**
     * Return bounds of this item and all child items
     *
     * @return {Ofcs.Bounds}
     */
    getFullBounds() {
        const fullBounds = this.getBounds().clone();

        this.getItems().each((item) => {
            const itemBounds = item.getFullBounds();
            fullBounds.extend(itemBounds.topLeft);
            fullBounds.extend(itemBounds.bottomRight);
        });

        return fullBounds;
    },
});

export default ContainerItem;
window.Ofcs.Editor.Item.ContainerItem = ContainerItem;
